export default __webpack_public_path__ + "static/media/army_12.85551d70.jpg";